import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { Dispute } from "pages/vendor/Disputes/Disputes"
import { useTranslation } from "react-i18next"
import { CurrentTapType } from "pages/vendor/Disputes/Disputes"
import { DisputeStatus } from "pages/vendor/Disputes/components/DisputeStatus"

interface DisputesTableProps {
  disputes: Dispute[]
  isAllChecked: boolean
  checkedDisputes: Dispute[]
  toggleAllDisputes: () => void
  checkedDisputeHandler: (dispute: Dispute) => void
  resolveHandler: (dispute: Dispute) => void
  rejectHandler: (dispute: Dispute) => void
  viewDetailsHandler: (dispute: Dispute) => void
  deleteProductHandler: (dispute: Dispute) => void
  forwardToAdminHandler: (dispute: Dispute) => void
  location?: any
}

const DisputesTable: React.FC<DisputesTableProps> = ({
  disputes,
  isAllChecked,
  checkedDisputes,
  checkedDisputeHandler,
  deleteProductHandler,
  forwardToAdminHandler,
  resolveHandler,
  toggleAllDisputes,
  rejectHandler,
  viewDetailsHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllDisputes}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return (
            <input
              onClick={() => checkedDisputeHandler(cellProps.row.original)}
              checked={Boolean(
                checkedDisputes.find(d => d.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("disputes_disputeTitle"),
        accessor: "title",
        filterable: true,
        filter: (rows: any[], id: string, filterValue: string) => {
          if (!filterValue || filterValue.trim() === '') return rows
          const searchTerm = String(filterValue).toLowerCase().trim()

          return rows.filter(row => {
            const { title, id } = row.original as Dispute
            const titleMatch = title.toLowerCase().includes(searchTerm)
            const idMatch = id.toLowerCase().includes(searchTerm)
            return titleMatch || idMatch 
          })
        },
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return (
            <div className="d-flex flex-column gap-1">
              <span>{cellProps.row.original.title}</span>
              <span className="fw-light">{cellProps.row.original.id}</span>
            </div>
            )
        },
      },
      {
        Header: t("common_createdDate"),
        accessor: "createdDate",
        filterable: true,
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return <>{cellProps.row.original.createdDate}</>
        },
      },
      {
        Header: t("common_createdBy"),
        accessor: "createdBy",
        filterable: true,
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return (
            <>
              <i className="bx bx-user-circle me-1" />
              {cellProps.row.original.createdBy}
            </>
          )
        },
      },
      {
        Header: t("common_attachments"),
        accessor: "attachments",
        filterable: true,
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return (
            <div className="d-flex flex-wrap">
              {cellProps.row.original.attachments.map((attachment, index) => (
                <span
                  key={index}
                  className="badge bg-secondary me-1 px-2 py-1 font-size-10"
                >
                  {attachment}
                </span>
              ))}
            </div>
          )
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Dispute } }) => {
          return <DisputeStatus disputeStatus={cellProps.row.original.status} />
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Dispute } }) => {
          const dispute = cellProps.row.original
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-vertical font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem onClick={() => viewDetailsHandler(dispute)}>
                  <span className="">{t("common_viewDetails")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => resolveHandler(dispute)}>
                  <span className="">{t("common_resolved")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => rejectHandler(dispute)}>
                  <span className="">{t("common_rejected")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => forwardToAdminHandler(dispute)}>
                  <span className="">{t("common_forwardToNartawi")}</span>
                </DropdownItem>
                {/* <DropdownItem onClick={() => deleteProductHandler(dispute)}>
                  <span className="text-danger">
                    {t("products_deleteProduct")}
                  </span>
                </DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    [disputes, t, checkedDisputes]
  )

  return (
    <TableContainer
      columns={columns}
      data={disputes}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

DisputesTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(DisputesTable))
